<script setup lang="ts">
import { SortItem } from "vuetify/lib/components/VDataTable/composables/sort";

const { headerKey, sortBy, align = "start" } = defineProps<{
	headerKey: string;
	sortBy: SortItem[];
	align?: "start" | "end";
}>();
</script>

<template>
	<v-hover v-slot="{ isHovering, props }">
		<div
			v-bind="props"
			class="flex-grow-1 d-flex align-center"
			:class="align === 'end' ? 'justify-end' : undefined"
			style="min-width: 0"
		>
			<slot />
			<v-icon
				v-if="isHovering || sortBy[0]?.key === headerKey"
				size="16"
				:class="[
					'flex-shrink-0',
					{ 'opacity-30': sortBy[0]?.key !== headerKey },
				]"
			>
				{{
					sortBy[0]?.order === "asc" || sortBy[0]?.key !== headerKey
						? "mdi-arrow-up"
						: "mdi-arrow-down"
				}}
			</v-icon>
		</div>
	</v-hover>
</template>
